import { Component, signal } from '@angular/core';

@Component({
  selector: 'dp-feedback-bar',
  templateUrl: './feedback-bar.component.html',
  standalone: false,
  styleUrls: ['./feedback-bar.component.scss']
})
export class DpFeedbackBarComponent {
  showFeedback = signal(false);

  toggleFeedback(): void {
    this.showFeedback.update(value => !value);
  }
}
